import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
export const containerSizesShop = {
  background: colorsPalette.brown10,

  paddingTop: '16px',
  paddingBottom: '16px',
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
  [MediaQueries.md]: {
    paddingBottom: '12px',
    paddingTop: '12px',
  },
};

export const NewShopBigGrid = {
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },

  '.fullwidthcardimgsec': {
    img: {},
  },
};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',

  [MediaQueries.xl]: {
    width: 'calc(100% - 64px)',
  },

  [MediaQueries.lg]: {
    width: 'calc(100% - 44px)',
  },
  [MediaQueries.md]: {
    width: 'calc(100% - 48px)',
  },

  '.fullwidthgrid': {
    paddingRight: '16px',
    paddingLeft: '16px',
    [MediaQueries.sm]: {
      paddingRight: '0px',
      paddingLeft: '0px',
    },
    [MediaQueries.md]: {
      paddingRight: '12px',
      paddingLeft: '12px',
    },
  },

  '.style-ImageText': {
    '.fullwidthcardimgsec': {
      [MediaQueries.sm]: {
        order: '2',
      },
      '.imgsec': {
        height: '100%',
      },
      img: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '16px 0px 0px 16px',
        position: 'absolute',
        [MediaQueries.sm]: {
          borderRadius: '0px 0px 16px 16px',
          width: '100%',
          maxHeight: 248,
          position: 'inherit',
        },
        [MediaQueries.md]: {
          borderRadius: '16px 0px 0px 16px',
          width: '100%',
        },
      },
    },
  },

  '.style-TextImage': {
    '.fullwidthcardimgsec': {
      '.imgsec': {
        height: '100%',
      },
      img: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '0px 16px 16px 0px',
        position: 'absolute',
        [MediaQueries.sm]: {
          borderRadius: '0px 0px 16px 16px',
          width: '100%',
          maxHeight: 248,
          position: 'inherit',
        },
        [MediaQueries.md]: {
          borderRadius: '0px 16px 16px 0px',
          width: '100%',
        },
      },
    },
  },

  '.grid-item-1': {
    // minHeight: '432px',
    [MediaQueries.sm]: {
      width: 'auto',
    },

    [MediaQueries.md]: {
      minHeight: 'auto',
    },
    [MediaQueries.lg]: {
      // minHeight: '368px',
    },
    h2: {
      fontSize: '58px',
      lineHeight: '56px',
      letterSpacing: '-1px',
      textAlign: 'left',
      fontWeight: '500',
      color: '#393939',
      [MediaQueries.sm]: {
        fontSize: '34px',
        lineHeight: '40px',
        letterSpacing: '-0.4px',
      },
      [MediaQueries.md]: {
        fontSize: '34px',
        lineHeight: '40px',
        letterSpacing: 'unset',
      },
      [MediaQueries.lg]: {
        fontSize: '40px',
        lineHeight: '48px',
        letterSpacing: '-0.3px',
      },
    },
  },

  '.mdsection:hover': {
    // cursor: 'pointer',
    borderColor: 'transparent',
    boxShadow: '0px 10px 80px rgb(0 0 0 / 8%)',
    outline: '0',
  },

  '.mdsection': {
    width: '100%',
    borderRadius: '16px',

    background: colorsPalette.white,
    marginLeft: '0px',
    marginRight: '0px',

    '.leftseccontent': {
      padding: '72px 50px',
      [MediaQueries.sm]: {
        padding: '32px 12px',
      },
      [MediaQueries.md]: {
        padding: '32px 12px',
      },
      [MediaQueries.lg]: {
        padding: '40px 20px',
      },

      '.findoutlink': {
        color: colorsPalette.red,
        marginTop: '48px',
        position: 'relative',

        [MediaQueries.lg]: {},
        [MediaQueries.md]: {},

        [MediaQueries.sm]: {
          display: 'inline-grid',
          position: 'relative',
        },

        a: {
          color: colorsPalette.red,
          textDecoration: 'none',
          marginRight: '30px',
          fontSize: '18px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '32px',
          textAlign: 'left',
          [MediaQueries.sm]: {
            fontSize: '16px',
          },
          [MediaQueries.md]: {
            fontSize: '16px',
          },

          'span:first-child': {
            borderBottom: `1px solid ${colorsPalette.red}`,
          },

          [MediaQueries.md]: {
            marginBottom: '24px',

            fontSize: '16px',
            lineHeight: '24PX',
          },

          [MediaQueries.sm]: {
            marginBottom: '24px',

            fontSize: '16px',
            lineHeight: '24PX',
          },
          i: {
            paddingLeft: '15px',
            position: 'relative',
            top: '3px',
            // paddingRight: '15px',
          },
        },

        'a:last-child': {
          [MediaQueries.sm]: {
            marginBottom: 0,
          },
        },
      },
    },

    p: {
      fontSize: '16px',
      fontStyle: 'normal',
      marginTop: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#747475',
      [MediaQueries.md]: {
        lineHeight: '24px',
      },
    },
  },

  [MediaQueries.sm]: {
    paddingBottom: '24px',
    paddingTop: '0px',
  },
});

export const imagefullwidthStyles = css({
  width: '100%',
});
